import { FC } from 'react';

import sortDownBlueIcon from '../../../../../assets/img/icon-sort-down_blue_24px.svg';
import sortDownGrayIcon from '../../../../../assets/img/icon-sort-down_gray_24px.svg';
import sortUpBlueIcon from '../../../../../assets/img/icon-sort-up_blue_24px.svg';
import sortUpGrayIcon from '../../../../../assets/img/icon-sort-up_gray_24px.svg';
import { MarketCapSortDirection } from '../../../MarketCapRadar.constants';

import styles from '../../MarketCapRadarInternal.module.scss';

type Props = {
  state: MarketCapSortDirection | null;
};

const MarketCapRadarSortIcon: FC<Props> = ({ state }) => (
  <span className={styles.headerSortIcon} aria-hidden="true">
    <img
      src={state === 'asc' ? sortUpBlueIcon : sortUpGrayIcon}
      alt=""
      className={styles.headerSortArrowUp}
    />
    <img
      src={state === 'desc' ? sortDownBlueIcon : sortDownGrayIcon}
      alt=""
      className={styles.headerSortArrowDown}
    />
  </span>
);

export default MarketCapRadarSortIcon;
